import React, { useEffect, useState, createElement, Component } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, MessageCircle, CalendarDays, Share2, Facebook, Link as LinkIcon, Clock, Users } from 'lucide-react';
import { initMetaPixel, trackPageView, trackLead } from '../utils/metaPixel';
import { trackPage } from '../utils/analytics';
const WHATSAPP_URL = 'https://chat.whatsapp.com/L0IuQzAJoSf6TfkaF8f4ml';
const REDIRECT_SECONDS = 10;
export function Gracias() {
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);
  const [popupBlocked, setPopupBlocked] = useState(false);
  // Meta Pixel & Analytics - PageView + Lead
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackLead();
    trackPage('/gracias');
  }, []);
  // Auto-open WhatsApp in a new tab after countdown (current page stays open)
  useEffect(() => {
    if (countdown <= 0) {
      trackPage('whatsapp_click');
      const newWindow = window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        // Popup was blocked by the browser — show fallback message
        setPopupBlocked(true);
      }
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);
  const webinarDate = '20260529T020000Z'; // 8:00 PM CDMX (UTC-6) = 2:00 AM UTC May 29
  const webinarDateEnd = '20260529T033000Z'; // 9:30 PM CDMX = 3:30 AM UTC May 29
  const webinarTitle = encodeURIComponent('Webinar: La Nueva Regla de Oro del Inversionista');
  const webinarDetails = encodeURIComponent('Aprende a construir una renta vitalicia con Susana Sanchez G.');
  const shareUrl = 'https://webinar.bienesraicesacademy.com/registro';
  const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${webinarDate}/${webinarDateEnd}&text=${webinarTitle}&details=${webinarDetails}`;
  const outlookCalendarUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${webinarDate}&enddt=${webinarDateEnd}&subject=${webinarTitle}&body=${webinarDetails}`;
  // Generate simple ICS content for Apple Calendar
  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${webinarDate}
DTEND:${webinarDateEnd}
SUMMARY:Webinar: La Nueva Regla de Oro del Inversionista
DESCRIPTION:Aprende a construir una renta vitalicia con Susana Sanchez G.
END:VEVENT
END:VCALENDAR`;
  const downloadIcs = () => {
    const blob = new Blob([icsContent], {
      type: 'text/calendar;charset=utf-8'
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', 'webinar-susana-sanchez.ics');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    alert('¡Enlace copiado al portapapeles!');
  };
  return <div className="min-h-screen bg-lightgray font-sans text-dark" data-id="element-128">
      {/* ABOVE THE FOLD - Success + WhatsApp */}
      <section className="px-4 pt-6 md:pt-10 pb-6" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-6 md:p-10 shadow-xl text-center border-t-8 border-gold-metallic" data-id="element-130">
          <CheckCircle className="w-14 h-14 md:w-16 md:h-16 text-green-500 mx-auto mb-3" data-id="element-131" />
          <h1 className="font-heading text-2xl md:text-4xl font-bold mb-2 text-dark" data-id="element-132">
            ¡Tu registro ha sido confirmado!
          </h1>
          <p className="text-base md:text-lg text-gray-600 mb-5" data-id="element-133">
            Estás a un paso de descubrir cómo construir tu renta vitalicia.
          </p>

          <div className="bg-pitahaya-light rounded-2xl p-4 md:p-6 border border-pitahaya/20" data-id="element-134">
            <h2 className="font-bold text-lg mb-2 text-pitahaya-dark flex items-center justify-center gap-2" data-id="element-135">
              <Users className="w-5 h-5" data-id="element-136" />
              Paso Final Obligatorio
            </h2>
            <p className="text-gray-700 mb-4 text-sm md:text-base" data-id="element-137">
              Únete al grupo exclusivo de WhatsApp donde enviaremos el enlace de
              acceso al webinar y material de preparación.
            </p>
            <motion.a whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(37, 211, 102, 0.4)', '0 0 0 12px rgba(37, 211, 102, 0)', '0 0 0 0 rgba(37, 211, 102, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage('whatsapp_click')} className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-colors w-full text-lg" data-id="element-138">
              <MessageCircle className="w-6 h-6" data-id="element-139" />
              UNIRME AL GRUPO DE WHATSAPP
            </motion.a>
            {popupBlocked ? <p className="mt-3 text-sm font-semibold text-pitahaya-dark" data-id="element-140">
                Hubo un error en la apertura automática. Por favor haz clic en
                el botón de arriba para unirte al grupo.
              </p> : countdown > 0 ? <p className="mt-3 text-sm text-gray-600" data-id="element-141">
                Se abrirá en una nueva pestaña en{' '}
                <span className="font-bold text-pitahaya-dark" data-id="element-142">
                  {countdown}
                </span>{' '}
                {countdown === 1 ? 'segundo' : 'segundos'}
                ...
              </p> : <p className="mt-3 text-sm text-gray-600" data-id="element-143">
                Abriendo WhatsApp en una nueva pestaña...
              </p>}
          </div>
        </motion.div>
      </section>

      {/* BELOW THE FOLD - Details, Calendar, Share */}
      <div className="max-w-3xl mx-auto px-4 pb-12 space-y-6" data-id="element-144">
        {/* EVENT DETAILS */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-2xl p-8 shadow-md" data-id="element-145">
          <h3 className="font-heading text-2xl font-bold mb-6 border-b pb-4" data-id="element-146">
            Detalles del Evento
          </h3>
          <div className="flex flex-col md:flex-row gap-6 md:gap-12" data-id="element-147">
            <div className="flex items-start gap-4" data-id="element-148">
              <CalendarDays className="w-8 h-8 text-pitahaya flex-shrink-0" data-id="element-149" />
              <div data-id="element-150">
                <p className="font-bold text-lg" data-id="element-151">Fecha</p>
                <p className="text-gray-600" data-id="element-152">Jueves, 28 de Mayo de 2026</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-153">
              <Clock className="w-8 h-8 text-pitahaya flex-shrink-0" data-id="element-154" />
              <div data-id="element-155">
                <p className="font-bold text-lg" data-id="element-156">Hora</p>
                <p className="text-gray-600" data-id="element-157">8:00 PM (Hora CDMX)</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-158">
              <Users className="w-8 h-8 text-pitahaya flex-shrink-0" data-id="element-159" />
              <div data-id="element-160">
                <p className="font-bold text-lg" data-id="element-161">Modalidad</p>
                <p className="text-gray-600" data-id="element-162">Online (Enlace vía WhatsApp)</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* CALENDAR SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-white rounded-2xl p-8 shadow-md text-center" data-id="element-163">
          <h3 className="font-heading text-2xl font-bold mb-6" data-id="element-164">
            Agrega el evento a tu calendario
          </h3>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-165">
            <button onClick={downloadIcs} className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-dark font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-166">
              <CalendarDays className="w-5 h-5" data-id="element-167" /> Apple Calendar
            </button>
            <a href={googleCalendarUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-dark font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-168">
              <CalendarDays className="w-5 h-5" data-id="element-169" /> Google Calendar
            </a>
            <a href={outlookCalendarUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-dark font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-170">
              <CalendarDays className="w-5 h-5" data-id="element-171" /> Outlook
            </a>
          </div>
        </motion.div>

        {/* SHARE SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-white rounded-2xl p-8 shadow-md text-center" data-id="element-172">
          <h3 className="font-heading text-2xl font-bold mb-2" data-id="element-173">
            Invita a tus conocidos
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-174">
            ¿Conoces a alguien que le interesaría construir una renta vitalicia?
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-175">
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#0d65d9] text-white font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-176">
              <Facebook className="w-5 h-5" data-id="element-177" /> Compartir en Facebook
            </a>
            <button onClick={copyLink} className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-900 text-white font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-178">
              <LinkIcon className="w-5 h-5" data-id="element-179" /> Copiar Enlace
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}